export default "__VITE_ASSET__CcfJBvyQ__"